import { Route } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { JhiLoginComponent } from './login.component';

export const loginRoute: Route = {
  path: 'login',
  component: JhiLoginComponent,
  data: {
    authorities: [],
    pageTitle: 'global.menu.account.login'
  },
  canActivate: [UserRouteAccessService]
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/login/login.state.ts